/* Ardor designers: print template download. Ardor Printing. This copy: assets/ardor-realestate-tpl.js, made Oct 19, 2026
(RE-CORE) from the LIVE assets/ardor-stand-tpl.js (unchanged; written Oct 12, 2026 by agent TPL-FLAGFAM for the flag,
table cover and banner stand designers) by the patch list realestate/core/tpl.patch, which adds the real estate sign
designer (window.ArdorRealestateBuilder / ArdorRealestateAPI): one page per printed side of each piece (sign front, sign
back, rider front, rider back), page = that piece's print template (no bleed), with the zones the hardware covers
(frame lip, clips, rider clamp, grommets), the holes, the visible edge and the dashed safe line.
- Adds a "Template" button to the tool rail (next to the PDF button, same style) and a line under the upload button in
the Artwork panel: "Working with a designer? Download the template for this size".
- The template is an Ardor-branded PDF made in the browser for the exact product, size and sides picked. The guides and
the note sit on their own layer ("Ardor guides - hide before saving"). No supplier name anywhere. */
(function () {
  'use strict';
  if (window.ArdorTemplatePDF && window.ArdorTemplatePDF.mounted) return;
  var LAYER = 'Ardor guides - hide before saving';
  var RED = [189, 37, 44], INK = [12, 13, 13], GREY = [52, 54, 62], WHITE = [255, 255, 255];
  var PHONE = '(425) 629-0796';

  // ---------- text: Helvetica / Helvetica-Bold widths (1/1000 em) for ASCII 32-126 ----------
  var HV = [278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556,
    1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556,
    333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584];
  var HB = [278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611,
    975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556,
    333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584];
  function ascii(s) {
    return String(s == null ? '' : s).replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, '-')
      .replace(/×/g, 'x').replace(/…/g, '...').replace(/ /g, ' ').replace(/[^\x20-\x7E]/g, '');
  }
  function tw(s, bold) { var t = 0, W = bold ? HB : HV; s = ascii(s); for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i) - 32; t += c >= 0 && c < 95 ? W[c] : 556; } return t / 1000; }
  function pstr(s) { return '(' + ascii(s).replace(/[\\()]/g, '\\$&') + ')'; }
  function n(v) { v = +v; if (!isFinite(v)) v = 0; var s = (Math.round(v * 10000) / 10000).toFixed(4).replace(/\.?0+$/, ''); return s === '-0' ? '0' : s; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function fmt(x) { return String(Math.round(x * 100) / 100); }
  // words -> lines no wider than maxW (inches) at this size
  function wrap(text, maxW, bold, size) {
    var words = ascii(text).split(/\s+/).filter(Boolean), lines = [], cur = '';
    words.forEach(function (w) {
      var t = cur ? cur + ' ' + w : w;
      if (!cur || tw(t, bold) * size <= maxW) cur = t; else { lines.push(cur); cur = w; }
    });
    if (cur) lines.push(cur);
    return lines;
  }

  // ---------- one PDF page: drawing in inches, y down from the page's top-left ----------
  function Page(W, H) { this.W = W; this.H = H; this.o = []; this.gs = {}; this.xo = {}; }
  Page.prototype = {
    op: function (s) { this.o.push(s); return this; },
    save: function () { return this.op('q'); },
    restore: function () { return this.op('Q'); },
    alpha: function (f, s) { var a = Math.round(clamp(f == null ? 1 : f, 0, 1) * 100), b = Math.round(clamp(s == null ? (f == null ? 1 : f) : s, 0, 1) * 100), k = 'A' + a + '_' + b; this.gs[k] = [a / 100, b / 100]; return this.op('/' + k + ' gs'); },
    fillRGB: function (c) { return this.op(n(c[0] / 255) + ' ' + n(c[1] / 255) + ' ' + n(c[2] / 255) + ' rg'); },
    strokeRGB: function (c) { return this.op(n(c[0] / 255) + ' ' + n(c[1] / 255) + ' ' + n(c[2] / 255) + ' RG'); },
    lw: function (w) { return this.op(n(w) + ' w'); },
    dash: function (a) { return this.op('[' + (a || []).map(n).join(' ') + '] 0 d'); },
    join: function (j) { return this.op(j + ' j'); },
    cap: function (c) { return this.op(c + ' J'); },
    moveTo: function (x, y) { return this.op(n(x) + ' ' + n(y) + ' m'); },
    lineTo: function (x, y) { return this.op(n(x) + ' ' + n(y) + ' l'); },
    rect: function (x, y, w, h) { return this.op(n(x) + ' ' + n(y) + ' ' + n(w) + ' ' + n(h) + ' re'); },
    poly: function (p, open) {
      if (!p || p.length < 2) return this;
      var s = n(p[0][0]) + ' ' + n(p[0][1]) + ' m';
      for (var i = 1; i < p.length; i++) s += ' ' + n(p[i][0]) + ' ' + n(p[i][1]) + ' l';
      return this.op(open ? s : s + ' h');
    },
    circle: function (cx, cy, r) {
      var k = 0.5523 * r;
      return this.op([n(cx + r), n(cy), 'm', n(cx + r), n(cy + k), n(cx + k), n(cy + r), n(cx), n(cy + r), 'c', n(cx - k), n(cy + r), n(cx - r), n(cy + k), n(cx - r), n(cy), 'c',
        n(cx - r), n(cy - k), n(cx - k), n(cy - r), n(cx), n(cy - r), 'c', n(cx + k), n(cy - r), n(cx + r), n(cy - k), n(cx + r), n(cy), 'c h'].join(' '));
    },
    fill: function (eo) { return this.op(eo ? 'f*' : 'f'); },
    stroke: function () { return this.op('S'); },
    clip: function (eo) { return this.op(eo ? 'W* n' : 'W n'); },
    transform: function (m) { return this.op(m.map(n).join(' ') + ' cm'); },
    // text at (x, y): o.size (inches), o.bold, o.align left|center|right, o.middle (y is the middle of capital letters),
    // o.rot (degrees clockwise), o.color
    text: function (s, x, y, o) {
      o = o || {}; s = ascii(s); if (!s) return this;
      var size = o.size || 1, bold = !!o.bold, w = tw(s, bold) * size;
      var dx = o.align === 'center' ? -w / 2 : (o.align === 'right' ? -w : 0), dy = o.middle ? size * 0.36 : 0;
      var r = (o.rot || 0) * Math.PI / 180, cs = Math.cos(r), sn = Math.sin(r);
      if (Math.abs(cs) < 1e-9) cs = 0; if (Math.abs(sn) < 1e-9) sn = 0;
      if (o.color) this.fillRGB(o.color);
      return this.op('BT /' + (bold ? 'F2' : 'F1') + ' ' + n(size) + ' Tf ' + [cs, sn, sn, -cs, x + dx * cs - dy * sn, y + dx * sn + dy * cs].map(n).join(' ') + ' Tm ' + pstr(s) + ' Tj ET');
    },
    image: function (name, x, y, w, h) { this.xo[name] = 1; return this.op('q ' + n(w) + ' 0 0 ' + n(-h) + ' ' + n(x) + ' ' + n(y + h) + ' cm /' + name + ' Do Q'); }
  };

  // ---------- PDF file ----------
  function latin(s) { var b = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 255; return b; }
  function deflate(bytes) {
    if (typeof CompressionStream === 'undefined' || typeof Response === 'undefined') return Promise.resolve(null);
    try {
      return new Response(new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate'))).arrayBuffer().then(function (b) { return new Uint8Array(b); }, function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  function streamObj(dict, bytes) {
    return deflate(bytes).then(function (z) {
      var data = z && z.length < bytes.length ? z : bytes;
      return { head: '<< ' + dict + (data === bytes ? '' : ' /Filter /FlateDecode') + ' /Length ' + data.length + ' >>', data: data };
    });
  }
  function pdfDate(d) { var p = function (x) { return String(x).padStart(2, '0'); }; return 'D:' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()); }
  // pages: [Page]; meta: { title, subject, keywords }; logo: { w, h, rgb, alpha } or null. Object ids are fixed:
  // 1 catalog, 2 pages, 3 layer (OCG), 4 Helvetica, 5 Helvetica-Bold, 6 info, then the logo (and its mask), then
  // one content stream + one page per page.
  function writePdf(meta, pages, logo) {
    var next = 7, logoId = 0, maskId = 0, jobs = [];
    if (logo) {
      logoId = next++; if (logo.alpha) maskId = next++;
      jobs.push(streamObj('/Type /XObject /Subtype /Image /Width ' + logo.w + ' /Height ' + logo.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8' + (maskId ? ' /SMask ' + maskId + ' 0 R' : ''), logo.rgb));
      if (maskId) jobs.push(streamObj('/Type /XObject /Subtype /Image /Width ' + logo.w + ' /Height ' + logo.h + ' /ColorSpace /DeviceGray /BitsPerComponent 8', logo.alpha));
    }
    var ids = pages.map(function () { var c = next++, p = next++; return { c: c, p: p }; });
    pages.forEach(function (pg) {
      jobs.push(streamObj('', latin('/OC /OC1 BDC\nq\n72 0 0 -72 0 ' + n(pg.H * 72) + ' cm\n' + pg.o.join('\n') + '\nQ\nEMC\n')));
    });
    return Promise.all(jobs).then(function (S) {
      var objs = {};
      objs[1] = { head: '<< /Type /Catalog /Pages 2 0 R /OCProperties << /OCGs [3 0 R] /D << /Name (Ardor template) /Order [3 0 R] /ON [3 0 R] /OFF [] /BaseState /ON >> >> /PageMode /UseOC /ViewerPreferences << /DisplayDocTitle true >> >>' };
      objs[2] = { head: '<< /Type /Pages /Kids [' + ids.map(function (x) { return x.p + ' 0 R'; }).join(' ') + '] /Count ' + ids.length + ' >>' };
      objs[3] = { head: '<< /Type /OCG /Name ' + pstr(LAYER) + ' /Intent /View /Usage << /View << /ViewState /ON >> /Print << /PrintState /ON >> /Export << /ExportState /ON >> >> >>' };
      objs[4] = { head: '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>' };
      objs[5] = { head: '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>' };
      var now = new Date();
      objs[6] = { head: '<< /Title ' + pstr(meta.title) + ' /Author (Ardor Printing) /Subject ' + pstr(meta.subject || '') + ' /Keywords ' + pstr(meta.keywords || '') + ' /Creator (ardorprinting.com) /Producer (Ardor Printing online designer) /CreationDate (' + pdfDate(now) + ') >>' };
      var k = 0;
      if (logoId) { objs[logoId] = S[k++]; if (maskId) objs[maskId] = S[k++]; }
      pages.forEach(function (pg, i) {
        objs[ids[i].c] = S[k++];
        var gs = Object.keys(pg.gs).map(function (g) { return '/' + g + ' << /Type /ExtGState /ca ' + n(pg.gs[g][0]) + ' /CA ' + n(pg.gs[g][1]) + ' >>'; }).join(' ');
        var xo = logoId && pg.xo.Logo ? ' /XObject << /Logo ' + logoId + ' 0 R >>' : '';
        objs[ids[i].p] = { head: '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + n(pg.W * 72) + ' ' + n(pg.H * 72) + '] /Resources << /Font << /F1 4 0 R /F2 5 0 R >>' + (gs ? ' /ExtGState << ' + gs + ' >>' : '') + xo + ' /Properties << /OC1 3 0 R >> /ProcSet [/PDF /Text /ImageC] >> /Contents ' + ids[i].c + ' 0 R >>' };
      });
      var parts = [latin('%PDF-1.6\n%âãÏÓ\n')], off = parts[0].length, xref = [];
      for (var id = 1; id < next; id++) {
        var o = objs[id]; xref[id] = off;
        var head = latin(id + ' 0 obj\n' + o.head + '\n' + (o.data ? 'stream\n' : ''));
        parts.push(head); off += head.length;
        if (o.data) { parts.push(o.data); off += o.data.length; var tail = latin('\nendstream\n'); parts.push(tail); off += tail.length; }
        var end = latin('endobj\n'); parts.push(end); off += end.length;
      }
      var hex = ''; for (var h = 0; h < 16; h++) hex += ('0' + Math.floor(Math.random() * 256).toString(16)).slice(-2);
      var x = 'xref\n0 ' + next + '\n0000000000 65535 f \n';
      for (var j = 1; j < next; j++) x += String(xref[j]).padStart(10, '0') + ' 00000 n \n';
      x += 'trailer\n<< /Size ' + next + ' /Root 1 0 R /Info 6 0 R /ID [<' + hex + '> <' + hex + '>] >>\nstartxref\n' + off + '\n%%EOF\n';
      parts.push(latin(x));
      return new Blob(parts, { type: 'application/pdf' });
    });
  }

  // ---------- the logo (assets/ardor-<designer>-logo.png), as RGB + alpha for the PDF ----------
  var logoP = null;
  function loadLogo(url) {
    if (logoP) return logoP;
    if (!url || typeof fetch === 'undefined' || typeof createImageBitmap === 'undefined') return (logoP = Promise.resolve(null));
    logoP = fetch(url).then(function (r) { return r.ok ? r.blob() : null; }).then(function (bl) { return bl ? createImageBitmap(bl) : null; }).then(function (bmp) {
      if (!bmp || !bmp.width) return null;
      var k = Math.min(1, 520 / bmp.width), w = Math.max(1, Math.round(bmp.width * k)), h = Math.max(1, Math.round(bmp.height * k));
      var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      var x = cv.getContext('2d'); x.drawImage(bmp, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, rgb = new Uint8Array(w * h * 3), al = new Uint8Array(w * h), any = false;
      for (var i = 0, j = 0; i < w * h; i++, j += 4) { rgb[i * 3] = d[j]; rgb[i * 3 + 1] = d[j + 1]; rgb[i * 3 + 2] = d[j + 2]; al[i] = d[j + 3]; if (d[j + 3] < 255) any = true; }
      cv.width = cv.height = 1;
      return { w: w, h: h, rgb: rgb, alpha: any ? al : null };
    }).catch(function () { return null; });
    return logoP;
  }

  // ---------- geometry helpers (inches) ----------
  function bbox(p) { var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9; p.forEach(function (q) { x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); x1 = Math.max(x1, q[0]); y1 = Math.max(y1, q[1]); }); return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 }; }
  function rectPts(x, y, w, h) { return [[x, y], [x + w, y], [x + w, y + h], [x, y + h]]; }
  function circlePts(cx, cy, r) { var out = []; for (var i = 0; i < 48; i++) { var t = i * Math.PI / 24; out.push([cx + r * Math.cos(t), cy + r * Math.sin(t)]); } return out; }
  // the inside part of a horizontal line through a polygon (the widest one)
  function spanAt(poly, y) {
    var xs = [];
    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var a = poly[j], b = poly[i];
      if ((a[1] > y) !== (b[1] > y)) xs.push(a[0] + (y - a[1]) * (b[0] - a[0]) / (b[1] - a[1]));
    }
    xs.sort(function (p, q) { return p - q; });
    var best = null;
    for (var k = 0; k + 1 < xs.length; k += 2) if (!best || xs[k + 1] - xs[k] > best[1] - best[0]) best = [xs[k], xs[k + 1]];
    return best;
  }
  // the inside part of the polygon for every height from y0 to y1 (null when a line misses it)
  function spanRange(poly, y0, y1) {
    var lo = -1e9, hi = 1e9;
    for (var i = 0; i <= 8; i++) { var s = spanAt(poly, y0 + (y1 - y0) * i / 8); if (!s) return null; lo = Math.max(lo, s[0]); hi = Math.min(hi, s[1]); }
    return hi > lo ? [lo, hi] : null;
  }
  function ptIn(poly, x, y) { var s = spanAt(poly, y); return !!s && x >= s[0] && x <= s[1]; }

  // ---------- the note: logo, product, side, page size, instructions and legend ----------
  // spec: { side, product, page, steps: [...], legend: [{ k: kind, t: text }] }. Height grows with fs (it scales).
  function noteRows(spec, fs, nw, logo) {
    var pad = fs * 1.1, inner = nw - pad * 2 - fs * 0.3, rows = [], y = pad;
    var lh = function (s) { return s * 1.28; };
    var headH = fs * 2.3;
    rows.push({ t: 'head', y: y, h: headH }); y += headH + fs * 0.7;
    var sideFs = fs * 1.45, sideL = wrap(spec.side, inner, true, sideFs);
    rows.push({ t: 'lines', y: y, lines: sideL, size: sideFs, bold: true, color: RED }); y += sideL.length * lh(sideFs) + fs * 0.25;
    var prodL = wrap(spec.product, inner, true, fs);
    rows.push({ t: 'lines', y: y, lines: prodL, size: fs, bold: true, color: INK }); y += prodL.length * lh(fs);
    var pageL = wrap(spec.page, inner, false, fs);
    rows.push({ t: 'lines', y: y, lines: pageL, size: fs, color: INK }); y += pageL.length * lh(fs) + fs * 0.7;
    var numW = tw('8. ', true) * fs;
    (spec.steps || []).forEach(function (s, i) {
      var L = wrap(s, inner - numW, false, fs);
      rows.push({ t: 'step', y: y, n: (i + 1) + '.', lines: L, size: fs, numW: numW }); y += L.length * lh(fs) + fs * 0.32;
    });
    y += fs * 0.45;
    var swW = fs * 2.2, lfs = fs * 0.92;
    (spec.legend || []).forEach(function (g) {
      var L = wrap(g.t, inner - swW - fs * 0.6, false, lfs);
      rows.push({ t: 'legend', y: y, k: g.k, lines: L, size: lfs, swW: swW }); y += Math.max(L.length * lh(lfs), fs * 1.1) + fs * 0.2;
    });
    return { rows: rows, h: y + pad - fs * 0.2, pad: pad };
  }
  function drawSwatch(pg, k, x, y, w, h, fs) {
    var lw = Math.max(fs * 0.07, 0.01), cy = y + h / 2;
    pg.save();
    if (k === 'bleed') { pg.alpha(0.16).fillRGB(RED).rect(x, y, w, h).fill(); pg.alpha(1).lw(lw * 0.6).strokeRGB([150, 150, 156]).rect(x, y, w, h).stroke(); }
    else if (k === 'cut' || k === 'visible') { pg.lw(lw * 1.4).strokeRGB(INK).moveTo(x, cy).lineTo(x + w, cy).stroke(); }
    else if (k === 'safe') { pg.lw(lw * 1.4).strokeRGB(RED).dash([fs * 0.42, fs * 0.28]).moveTo(x, cy).lineTo(x + w, cy).stroke(); }
    else if (k === 'fold' || k === 'trim') { pg.lw(lw * 1.1).strokeRGB(INK).dash(k === 'fold' ? [fs * 0.5, fs * 0.36] : [fs * 0.22, fs * 0.22]).moveTo(x, cy).lineTo(x + w, cy).stroke(); }
    else if (k === 'panel') { pg.lw(lw * 1.2).cap(1).strokeRGB([90, 90, 98]).dash([0, fs * 0.3]).moveTo(x, cy).lineTo(x + w, cy).stroke(); }
    else if (k === 'sleeve') { pg.alpha(0.88).fillRGB([22, 22, 27]).rect(x, y + h * 0.15, w, h * 0.7).fill(); }
    else if (k === 'hidden') { pg.alpha(0.6).fillRGB(GREY).rect(x, y + h * 0.1, w, h * 0.8).fill(); }
    else if (k === 'outside') { pg.alpha(0.22).fillRGB([120, 122, 132]).rect(x, y + h * 0.1, w, h * 0.8).fill(); }
    else if (k === 'pocket') { pg.alpha(0.2).fillRGB(GREY).rect(x, y + h * 0.1, w, h * 0.8).fill(); pg.alpha(0.5).lw(lw).strokeRGB(GREY); for (var hx = x; hx < x + w; hx += fs * 0.35) pg.moveTo(hx, y + h * 0.9).lineTo(Math.min(x + w, hx + h * 0.8), y + h * 0.1); pg.stroke(); }
    else if (k === 'grommet') { pg.fillRGB(WHITE).circle(x + w / 2, cy, h * 0.3).fill(); pg.lw(lw * 1.3).strokeRGB([70, 72, 80]).circle(x + w / 2, cy, h * 0.3).stroke(); }
    else if (k === 'arrow') { arrow(pg, x + w / 2, cy, h * 0.9, [40, 40, 46], 1); }
    pg.restore();
  }
  // an arrow pointing up (toward smaller y) centered at (x, y), h tall
  function arrow(pg, x, y, h, col, a) {
    var hw = h * 0.32, top = y - h / 2, bot = y + h / 2, neck = top + h * 0.42;
    pg.save().alpha(a == null ? 1 : a).fillRGB(col);
    pg.poly([[x, top], [x + hw, neck], [x + hw * 0.36, neck], [x + hw * 0.36, bot], [x - hw * 0.36, bot], [x - hw * 0.36, neck], [x - hw, neck]]).fill();
    return pg.restore();
  }
  function drawNote(pg, x, y, spec, fs, nw, logo) {
    var L = noteRows(spec, fs, nw, logo), lh = function (s) { return s * 1.28; }, pad = L.pad, tx = x + pad + fs * 0.3;
    pg.save();
    pg.alpha(0.95).fillRGB(WHITE).rect(x, y, nw, L.h).fill();
    pg.alpha(1).lw(Math.max(fs * 0.05, 0.01)).strokeRGB([200, 200, 206]).rect(x, y, nw, L.h).stroke();
    pg.fillRGB(RED).rect(x, y, fs * 0.3, L.h).fill();
    L.rows.forEach(function (r) {
      var ry = y + r.y;
      if (r.t === 'head') {
        var lx = tx, h = r.h;
        if (logo) { var lw = h * logo.w / logo.h; if (lw > nw * 0.55) { lw = nw * 0.55; h = lw * logo.h / logo.w; } pg.image('Logo', lx, ry + (r.h - h) / 2, lw, h); lx += lw + fs * 0.8; }
        else { pg.text('ARDOR PRINTING', lx, ry + r.h * 0.42, { size: fs * 1.15, bold: true, color: INK, middle: true }); lx += tw('ARDOR PRINTING', true) * fs * 1.15 + fs * 0.8; }
        pg.text('Print template', lx, ry + r.h * 0.34, { size: fs * 1.05, bold: true, color: INK, middle: true });
        pg.text('ardorprinting.com  |  ' + PHONE, lx, ry + r.h * 0.8, { size: fs * 0.85, color: [70, 70, 78], middle: true });
      } else if (r.t === 'lines') {
        r.lines.forEach(function (s, i) { pg.text(s, tx, ry + i * lh(r.size) + r.size * 0.9, { size: r.size, bold: r.bold, color: r.color }); });
      } else if (r.t === 'step') {
        pg.text(r.n, tx, ry + r.size * 0.9, { size: r.size, bold: true, color: RED });
        r.lines.forEach(function (s, i) { pg.text(s, tx + r.numW, ry + i * lh(r.size) + r.size * 0.9, { size: r.size, color: INK }); });
      } else if (r.t === 'legend') {
        drawSwatch(pg, r.k, tx, ry + r.size * 0.05, r.swW, r.size * 1.05, fs);
        r.lines.forEach(function (s, i) { pg.text(s, tx + r.swW + fs * 0.6, ry + i * lh(r.size) + r.size * 0.9, { size: r.size, color: INK }); });
      }
    });
    return pg.restore();
  }
  // the biggest note that fits inside the region polygon (centered on its widest middle part). The line length k (in
  // font sizes) grows on wide, short regions so the note gets wider instead of smaller.
  function placeNote(pg, region, spec, logo) {
    var bb = bbox(region), best = null;
    [30, 40, 52, 66].forEach(function (k) {
      var ratio = noteRows(spec, 1, k, logo).h / k; // note height per inch of note width
      [0.5, 0.44, 0.56, 0.38, 0.62].forEach(function (t) {
        var yc = bb.y + bb.h * t, nw = Math.min(bb.w, 1.1 * k), ok = false;
        for (var it = 0; it < 10; it++) {
          var sr = spanRange(region, yc - nw * ratio / 2, yc + nw * ratio / 2);
          if (!sr) { nw *= 0.85; continue; }
          var fit = Math.min(nw, (sr[1] - sr[0]) * 0.94);
          if (fit >= nw - 0.01) { ok = true; break; }
          nw = fit;
        }
        if (!ok) return;
        var fs = Math.min(nw / k, 1.1);
        if (!best || fs > best.fs * 1.06) {
          var w = fs * k, sr2 = spanRange(region, yc - w * ratio / 2, yc + w * ratio / 2) || [bb.x, bb.x + bb.w];
          best = { fs: fs, k: k, yc: yc, xc: (sr2[0] + sr2[1]) / 2 };
        }
      });
    });
    if (!best) best = { fs: clamp(bb.w * 0.9 / 30, 0.08, 1.1), k: 30, yc: bb.y + bb.h / 2, xc: bb.x + bb.w / 2 };
    var fs = Math.max(0.08, best.fs), nw = fs * best.k, L = noteRows(spec, fs, nw, logo);
    drawNote(pg, best.xc - nw / 2, best.yc - L.h / 2, spec, fs, nw, logo);
    return { x: best.xc - nw / 2, y: best.yc - L.h / 2, w: nw, h: L.h, fs: fs };
  }

  // common steps of the note
  function baseSteps(o) {
    var s = ['Extend the background to the outer edge of the page (the bleed is trimmed off).', 'Keep words and logos inside the dashed red line.'];
    (o.extra || []).forEach(function (x) { s.push(x); });
    if (o.twoSided) s.push('One page per side. Save each side as its own file and upload it on the Front or Back tab.');
    s.push('Before you save, hide or delete the layer "' + LAYER + '". It holds these guides and this note.');
    s.push('Save a PDF, JPG or PNG at this page size (100% scale, up to 25 MB) and upload it in our online designer. It is placed edge to edge.');
    return s;
  }
  function lineW(W, H) { return clamp(Math.min(W, H) * 0.0022, 0.02, 0.12); }
  function safeLine(pg, lw, path) {
    pg.save(); path(); pg.alpha(0.75).lw(lw * 2.4).strokeRGB(WHITE).stroke(); pg.restore();
    pg.save(); path(); pg.lw(lw * 1.3).strokeRGB(RED).dash([lw * 12, lw * 8]).stroke(); pg.restore();
  }
  // a label across or along a zone (turned when the zone is tall and thin); skipped when too small
  function zoneText(pg, txt, z, col, lw) {
    var turn = z.h > z.w * 1.4, thick = turn ? z.w : z.h, len = turn ? z.h : z.w;
    var fs = Math.min(thick * 0.5, 1.4, len * 0.9 / Math.max(1, tw(txt, true)));
    if (fs < 0.18) return;
    pg.text(txt, z.x + z.w / 2, z.y + z.h / 2, { size: fs, bold: true, color: col || WHITE, align: 'center', middle: true, rot: turn ? 270 : 0 });
  }
  function slug(s) { return ascii(s).replace(/(\d)\s*x\s*(\d)/gi, '$1x$2').replace(/[^A-Za-z0-9.]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, ''); }
  function titleCase(s) { return ascii(s).replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
  // the size part of a file name without the words the product part already has ("Standard 33 x 81 in" -> "33 x 81 in")
  function sizeOnly(size, product) {
    var have = {}; ascii(product).toLowerCase().split(/[^a-z]+/).forEach(function (w) { if (w) have[w] = 1; });
    var out = ascii(size).split(/\s+/).filter(function (w) { return !(/^[a-z]+$/i.test(w) && have[w.toLowerCase()]); }).join(' ');
    return out || size;
  }

  // ---------- flags: one page per printed face (front; back as seen from the back) ----------
  function flagDoc(B, logo) {
    var c = B.cfg(), info = B.tplInfo ? B.tplInfo() : {}, W = c.Wi, H = c.Hi, lw = lineW(W, H);
    var faces = c.sides === 2 ? [['front', 'FRONT'], ['back-flat', 'BACK (as seen from the back)']] : [['front', 'FRONT (1 side: printed through, the back shows it in reverse)']];
    var pages = faces.map(function (fc) {
      var G = B.geo(c, fc[0]), pg = new Page(W, H);
      // bleed: the page outside the cut line
      pg.save().alpha(0.14).fillRGB(RED).rect(0, 0, W, H).poly(G.cut).fill(true).restore();
      // the pole sleeve: sewn on along the pole edge, not printed
      if (G.sleeve && G.sleeve.length) {
        pg.save();
        if (G.run) {
          pg.rect(-W, -H, 3 * W, 3 * H).poly(G.cut).clip(true);
          pg.alpha(0.88).strokeRGB([22, 22, 27]).lw(2 * G.sleeveW).join(1).cap(0).poly(G.run, true).stroke();
        } else {
          if (!G.sleeveOut) pg.poly(G.cut).clip();
          pg.alpha(G.sleeveOut ? 0.88 : 0.34).fillRGB([22, 22, 27]);
          G.sleeve.forEach(function (p) { pg.poly(p).fill(); });
        }
        pg.restore();
        var all = [].concat.apply([], G.sleeve), sb = bbox(all);
        zoneText(pg, 'POLE SLEEVE - SEWN ON, NOT PRINTED', sb, WHITE, lw);
      }
      // cut line and safe line
      pg.save().lw(lw * 1.3).strokeRGB(INK).join(1).poly(G.cut).stroke().restore();
      (G.safe || []).forEach(function (p) { safeLine(pg, lw, function () { pg.join(1).poly(p); }); });
      var region = (G.safe && G.safe[0] && G.safe[0].length > 2) ? G.safe[0] : G.cut;
      var legend = [{ k: 'bleed', t: 'Bleed: the tinted area is trimmed off. Extend your background into it.' }, { k: 'cut', t: 'Cut line: the finished edge of the flag.' }, { k: 'safe', t: 'Safe line: keep words and logos inside it.' }];
      if (G.sleeve && G.sleeve.length) legend.push({ k: 'sleeve', t: 'Pole sleeve: sewn on along the pole edge, not printed.' });
      var extra = [];
      if (G.sleeve && G.sleeve.length) extra.push('The black band is the pole sleeve: it is sewn on and not printed.');
      if (c.sides === 1 && info.pole) extra.push('Pole on the ' + info.pole + ' (as seen from the front).');
      placeNote(pg, region, {
        side: fc[1], product: (info.product || 'Flag') + ' - ' + (info.size || ''),
        page: 'Template page ' + fmt(W) + ' x ' + fmt(H) + ' in (width x height), bleed included. This is the print size: keep it at 100%.',
        steps: baseSteps({ twoSided: c.sides === 2, extra: extra }), legend: legend
      }, logo);
      pg.label = fc[1];
      return pg;
    });
    var sidesTxt = c.sides === 2 ? '2-Sided' : '1-Side' + (info.pole ? '-Pole-' + titleCase(info.pole) : '');
    return { pages: pages, name: 'Ardor-Template-' + slug(titleCase(String(info.product || 'Flag').replace(/\s*\([^)]*\)/g, ''))) + '-' + slug(sizeOnly(info.sizeName || c.key, info.product || '')) + '-' + sidesTxt + '.pdf',
      title: 'Ardor Printing print template - ' + (info.product || 'Flag') + ', ' + (info.size || '') + ', ' + (c.sides === 2 ? '2 sides' : '1 side'), data: { flag: c.key, sides: c.sides, pole: info.pole || '' } };
  }

  // ---------- table covers: one page = the whole flat cover, panels outlined and labelled with their up arrow ----------
  function cutBox(cv) {
    var c = cv.cut || {};
    if (c.type === 'circle') return { x: c.cx - c.r, y: c.cy - c.r, w: 2 * c.r, h: 2 * c.r };
    if (c.type === 'poly' && c.pts && c.pts.length > 2) return bbox(c.pts);
    if (c.type === 'pieces' && c.pieces) { var all = []; Object.keys(c.pieces).forEach(function (k) { var b = cutBox({ cut: c.pieces[k], tpl: cv.tpl }); all.push([b.x, b.y], [b.x + b.w, b.y + b.h]); }); if (all.length) return bbox(all); }
    var r = c.rect || [0, 0, cv.tpl[0], cv.tpl[1]];
    return { x: +r[0], y: +r[1], w: +r[2], h: +r[3] };
  }
  function cutPath(pg, cut, tpl) {
    var c = cut || {};
    if (c.type === 'circle') pg.circle(+c.cx, +c.cy, +c.r);
    else if (c.type === 'poly' && c.pts && c.pts.length > 2) pg.poly(c.pts);
    else if (c.type === 'pieces' && c.pieces) Object.keys(c.pieces).forEach(function (k) { cutPath(pg, c.pieces[k], tpl); });
    else { var r = c.rect || [0, 0, tpl[0], tpl[1]]; pg.rect(+r[0], +r[1], +r[2], +r[3]); }
  }
  function R4(a) { return a && a.length === 4 ? a.map(Number) : [0, 0, 0, 0]; }
  function panelPath(pg, p) {
    if (p.clip && p.clip.circle) { var q = p.clip.circle; pg.circle(+q[0], +q[1], +q[2]); }
    else if (p.clip && p.clip.poly && p.clip.poly.length > 2) pg.poly(p.clip.poly);
    else { var r = R4(p.rect); pg.rect(r[0], r[1], r[2], r[3]); }
  }
  // a panel's safe area on the template (same rule as the designer: the panel inside the cut line, the safe distance in)
  function tableSafe(cv, p) {
    var s = +cv.safe || 1;
    if (p.safePoly && p.safePoly.length > 2) return { poly: p.safePoly };
    if (p.clip && p.clip.circle) { var q = p.clip.circle; return { circle: [+q[0], +q[1], Math.max(1, q[2] - s)] }; }
    var r = R4(p.rect), cb = cutBox(cv);
    var x0 = Math.max(r[0], cb.x), y0 = Math.max(r[1], cb.y), x1 = Math.min(r[0] + r[2], cb.x + cb.w), y1 = Math.min(r[1] + r[3], cb.y + cb.h);
    return { rect: [x0 + s, y0 + s, Math.max(1, x1 - x0 - 2 * s), Math.max(1, y1 - y0 - 2 * s)] };
  }
  function safePts(sf) { return sf.poly ? sf.poly : (sf.circle ? circlePts(sf.circle[0], sf.circle[1], sf.circle[2]) : rectPts(sf.rect[0], sf.rect[1], sf.rect[2], sf.rect[3])); }
  function apply(m, x, y) { return [m[0] * x + m[2] * y + m[4], m[1] * x + m[3] * y + m[5]]; }
  function tableDoc(B, logo) {
    var c = B.cfg(), cv = c.cv, info = B.tplInfo ? B.tplInfo() : {}, W = +cv.tpl[0], H = +cv.tpl[1], lw = lineW(W, H);
    var pg = new Page(W, H);
    pg.save().alpha(0.14).fillRGB(RED).rect(0, 0, W, H); cutPath(pg, cv.cut, cv.tpl); pg.fill(true).restore();
    pg.save().lw(lw * 1.3).strokeRGB(INK).join(1); cutPath(pg, cv.cut, cv.tpl); pg.stroke().restore();
    if (cv.folds && cv.folds.length) {
      pg.save().lw(lw * 1.1).strokeRGB(INK).alpha(0.8).dash([lw * 14, lw * 10]);
      cv.folds.forEach(function (f) { pg.moveTo(+f[0], +f[1]).lineTo(+f[2], +f[3]); });
      pg.stroke().restore();
    }
    var panels = (cv.panels || []).map(function (p) { var q = B.panel(p.id); return q ? { p: p, q: q } : null; }).filter(Boolean);
    // the note goes on the top panel (else the biggest one)
    var host = panels.filter(function (x) { return x.p.id === 'top'; })[0] || panels.slice().sort(function (a, b) { return b.q.page.W * b.q.page.H - a.q.page.W * a.q.page.H; })[0];
    var region = null;
    panels.forEach(function (x) {
      var p = x.p, q = x.q, pw = q.page.W, ph = q.page.H, m = q.mat;
      pg.save().lw(lw * 1.1).cap(1).strokeRGB([90, 90, 98]).alpha(0.75).dash([0, lw * 4]); panelPath(pg, p); pg.stroke().restore();
      var sf = tableSafe(cv, p);
      safeLine(pg, lw, function () { if (sf.circle) pg.circle(sf.circle[0], sf.circle[1], sf.circle[2]); else pg.poly(safePts(sf)); });
      // the label: the panel's name with an arrow on each side pointing to the top of its art, upright like its art
      var name = String(p.name || q.name || 'Panel').toUpperCase(), fs = clamp(Math.min(pw * 0.06, ph * 0.13), 0.3, 2.2);
      var isHost = host && x === host, cy = isHost ? Math.min(ph / 2, (+cv.safe || 1) + fs * 1.4) : ph / 2;
      if (p.clip && p.clip.circle && isHost) cy = Math.max(cy, ph * 0.2);
      var half = tw(name, true) * fs / 2 + fs * 1.3;
      pg.save().transform(m);
      pg.save().alpha(0.62).text(name, pw / 2, cy, { size: fs, bold: true, color: [40, 40, 46], align: 'center', middle: true }).restore();
      arrow(pg, pw / 2 - half, cy, fs * 1.3, [40, 40, 46], 0.62); arrow(pg, pw / 2 + half, cy, fs * 1.3, [40, 40, 46], 0.62);
      pg.restore();
      if (isHost) {
        // the host panel's safe area without the label band, in template inches
        var sp = safePts(sf), band = cy + fs * 1.6;
        var keep = sp.map(function (pt) { return pt; });
        // the band is at the top of the upright panel: cut it off in upright coordinates (inverse of m), then map back
        var d = m[0] * m[3] - m[1] * m[2], iv = [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[3] * m[4]) / d, (m[1] * m[4] - m[0] * m[5]) / d];
        var up = keep.map(function (pt) { return apply(iv, pt[0], pt[1]); });
        var ub = bbox(up);
        if (ub.y < band && ub.y + ub.h > band + 2) {
          // clip the upright safe polygon to v >= band (keeps the circle / polygon shape)
          var out = [], N = up.length;
          for (var i = 0; i < N; i++) {
            var a = up[i], b = up[(i + 1) % N], ia = a[1] >= band, ib = b[1] >= band;
            if (ia) out.push(a);
            if (ia !== ib) { var t = (band - a[1]) / (b[1] - a[1]); out.push([a[0] + (b[0] - a[0]) * t, band]); }
          }
          if (out.length > 2) up = out;
        }
        region = up.map(function (pt) { return apply(m, pt[0], pt[1]); });
      }
    });
    if (!region) { var cb = cutBox(cv); region = rectPts(cb.x + cb.w * 0.2, cb.y + cb.h * 0.2, cb.w * 0.6, cb.h * 0.6); }
    var legend = [{ k: 'bleed', t: 'Bleed: the tinted area is trimmed off. Extend your background into it.' }, { k: 'cut', t: 'Cut line: the finished (hemmed) edge.' }];
    if (cv.folds && cv.folds.length) legend.push({ k: 'fold', t: 'Dashed black lines: the table edges.' });
    legend.push({ k: 'panel', t: 'Dotted lines: panel edges.' }, { k: 'arrow', t: 'Arrows: the top of that panel\'s art (toward the table top).' }, { k: 'safe', t: 'Safe line: keep words and logos inside it.' });
    var names = panels.map(function (x) { return x.p.name || x.q.name; }).filter(Boolean);
    placeNote(pg, region, {
      side: 'WHOLE COVER, LAID FLAT (' + names.length + ' panel' + (names.length === 1 ? '' : 's') + ': ' + names.join(', ') + ')',
      product: (info.cover || info.product || 'Table cover') + (info.fits ? ', ' + info.fits : ''),
      page: 'Template page ' + fmt(W) + ' x ' + fmt(H) + ' in (width x height), bleed included. This is the print size: keep it at 100%.',
      steps: baseSteps({ extra: ['Design every panel upright, with its top toward the arrows. Where the cover has no panel (the corners), use your background.'] }), legend: legend
    }, logo);
    pg.label = 'WHOLE COVER';
    var sides = info.sidesText ? (/4/.test(info.sidesText) ? '-4-Sided' : (/3/.test(info.sidesText) ? '-3-Sided' : '')) : '';
    return { pages: [pg], name: 'Ardor-Template-' + slug(titleCase(info.product || 'Table Cover')) + '-' + slug(sizeOnly(info.sizeName || c.key, info.product || '')) + sides + '-Whole-Cover.pdf',
      title: 'Ardor Printing print template - ' + (info.cover || 'Table cover'), data: { cover: c.key, panels: names.length } };
  }

  // ---------- banner stands: one page per printed side ----------
  function standDoc(B, logo) {
    var c = B.cfg(), info = B.tplInfo ? B.tplInfo() : {}, W = c.Wi, H = c.Hi, lw = lineW(W, H);
    var faces = c.sides === 2 ? [['front', 'FRONT'], ['back-flat', 'BACK (as seen from the back)']] : [['front', 'FRONT (1 side)']];
    var pages = faces.map(function (fc) {
      var G = B.geo(c, fc[0]), v = G.vis, pg = new Page(W, H), legend = [], extra = [];
      // outside the visible area: does not show on the stand
      pg.save().alpha(0.2).fillRGB([120, 122, 132]).rect(0, 0, W, H).rect(v.x, v.y, v.w, v.h).fill(true).restore();
      var kinds = {};
      (G.hidden || []).forEach(function (z) { pg.save().alpha(0.55).fillRGB(GREY).rect(z.x, z.y, z.w, z.h).fill().restore(); });
      (G.hidden || []).slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; }).forEach(function (z) {
        var t = String(z.why || 'Hidden').toUpperCase(); if (kinds[t]) return; kinds[t] = 1; zoneText(pg, t, z, WHITE, lw);
      });
      // bleed: outside the trim line, or outside the cut outline (tension fabric)
      if (G.cutPoly) { pg.save().alpha(0.16).fillRGB(RED).rect(0, 0, W, H).poly(G.cut).fill(true).restore(); pg.save().lw(lw * 1.3).strokeRGB(INK).join(1).poly(G.cut).stroke().restore(); }
      else if (G.bleed > 0) {
        var t0 = G.trim;
        pg.save().alpha(0.16).fillRGB(RED).rect(0, 0, W, H).rect(t0.x, t0.y, t0.w, t0.h).fill(true).restore();
        pg.save().lw(lw).strokeRGB(INK).dash([lw * 5, lw * 5]).rect(t0.x, t0.y, t0.w, t0.h).stroke().restore();
      }
      (G.pockets || []).forEach(function (z) {
        pg.save().rect(z.x, z.y, z.w, z.h).clip();
        pg.alpha(0.18).fillRGB(GREY).rect(z.x, z.y, z.w, z.h).fill();
        pg.alpha(0.4).lw(lw).strokeRGB(GREY); var st = Math.max(lw * 14, 0.6);
        for (var hx = z.x - z.h; hx < z.x + z.w; hx += st) pg.moveTo(hx, z.y + z.h).lineTo(hx + z.h, z.y);
        pg.stroke().restore();
        zoneText(pg, String(z.why || 'Pole pocket').toUpperCase(), z, GREY, lw);
      });
      // the visible area's edge (stops at the outline on tension fabric)
      pg.save(); if (G.cutPoly) pg.poly(G.cut).clip();
      pg.lw(lw * 1.3).strokeRGB(INK).rect(v.x, v.y, v.w, v.h).stroke().restore();
      (G.grommets || []).forEach(function (q) {
        var r = Math.max(0.3, lw * 6);
        pg.save().fillRGB(WHITE).circle(q[0], q[1], r).fill().lw(Math.max(lw * 1.6, r * 0.4)).strokeRGB([70, 72, 80]).circle(q[0], q[1], r).stroke().restore();
      });
      (G.safe || []).forEach(function (p) { safeLine(pg, lw, function () { pg.poly(p); }); });
      legend.push({ k: 'visible', t: 'Visible edge: the part that shows on the assembled stand.' });
      if (G.cutPoly || G.bleed > 0) legend.push({ k: 'bleed', t: 'Bleed: the tinted edge is trimmed off. Extend your background into it.' });
      if (!G.cutPoly && G.bleed > 0) legend.push({ k: 'trim', t: 'Dashed black line: the trim line.' });
      if ((G.hidden || []).length) { legend.push({ k: 'hidden', t: 'Grey: prints, but is hidden in the stand.' }); extra.push('Grey areas print but are hidden in the stand (' + Object.keys(kinds).map(function (k) { return k.toLowerCase(); }).join(', ') + '). Run your background through them.'); }
      if ((G.pockets || []).length) { legend.push({ k: 'pocket', t: 'Hatched bands: pole pockets. Keep words out of them.' }); extra.push('Keep words and logos out of the hatched pole pockets.'); }
      if ((G.grommets || []).length) legend.push({ k: 'grommet', t: 'Circles: grommet holes.' });
      legend.push({ k: 'outside', t: 'Light grey: outside the visible area.' }, { k: 'safe', t: 'Safe line: keep words and logos inside it.' });
      var region = (G.safe && G.safe[0] && G.safe[0].length > 2) ? G.safe[0] : rectPts(v.x, v.y, v.w, v.h);
      placeNote(pg, region, {
        side: fc[1], product: (info.product || 'Banner stand') + ' - ' + (info.size || ''),
        page: 'Template page ' + fmt(W) + ' x ' + fmt(H) + ' in (width x height), bleed and hidden areas included. This is the print size: keep it at 100%.',
        steps: baseSteps({ twoSided: c.sides === 2, extra: extra }), legend: legend
      }, logo);
      pg.label = fc[1];
      return pg;
    });
    return { pages: pages, name: 'Ardor-Template-' + slug(titleCase(info.product || 'Banner Stand')) + '-' + slug(sizeOnly(info.sizeName || c.key, info.product || '')) + '-' + (c.sides === 2 ? '2-Sided' : '1-Side') + '.pdf',
      title: 'Ardor Printing print template - ' + (info.product || 'Banner stand') + ', ' + (info.size || ''), data: { stand: c.key, sides: c.sides } };
  }

  // ---------- real estate signs: one page per printed side of the sign and the rider ----------
  function realestateDoc(B, logo) {
    var c = B.cfg(), info = B.tplInfo ? B.tplInfo() : {};
    var faces = [['front', c.sides === 2 ? 'SIGN FRONT' : 'SIGN (1 side)']];
    if (c.sides === 2) faces.push(['back', 'SIGN BACK (as seen from the back)']);
    if (c.rider) { faces.push(['rider-front', c.rsides === 2 ? 'RIDER FRONT' : 'RIDER (1 side)']); if (c.rsides === 2) faces.push(['rider-back', 'RIDER BACK (as seen from the back)']); }
    var pages = faces.map(function (fc) {
      var G = B.geo(c, fc[0]), W = G.W, H = G.H, lw = lineW(W, H), v = G.vis, pg = new Page(W, H), legend = [], extra = [];
      var rider = /^rider/.test(fc[0]);
      // outside the visible area: does not show when the sign is up
      if (v.x > 0.001 || v.y > 0.001 || v.w < W - 0.002 || v.h < H - 0.002) pg.save().alpha(0.2).fillRGB([120, 122, 132]).rect(0, 0, W, H).rect(v.x, v.y, v.w, v.h).fill(true).restore();
      var kinds = {};
      (G.hidden || []).forEach(function (z) { pg.save().alpha(0.55).fillRGB(GREY).rect(z.x, z.y, z.w, z.h).fill().restore(); });
      (G.hidden || []).slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; }).forEach(function (z) {
        var t = String(z.why || 'Hidden').toUpperCase(); if (kinds[t]) return; kinds[t] = 1; zoneText(pg, t, z, WHITE, lw);
      });
      (G.keep || []).forEach(function (z) { pg.save().alpha(0.18).fillRGB(GREY).rect(z.x, z.y, z.w, z.h).fill().restore(); });
      pg.save().lw(lw * 1.3).strokeRGB(INK).rect(v.x, v.y, v.w, v.h).stroke().restore();
      (G.holes || []).forEach(function (h) {
        var r = Math.max(h[2] / 2, lw * 4);
        pg.save().fillRGB(WHITE).circle(h[0], h[1], r).fill().lw(Math.max(lw * 1.6, r * 0.4)).strokeRGB([70, 72, 80]).circle(h[0], h[1], r).stroke().restore();
      });
      (G.safe || []).forEach(function (p) { safeLine(pg, lw, function () { pg.poly(p); }); });
      legend.push({ k: 'visible', t: 'Visible edge: the part that shows when the sign is up.' });
      if ((G.hidden || []).length) { legend.push({ k: 'hidden', t: 'Grey: prints, but the hardware covers it.' }); extra.push('Grey areas print but are covered by the hardware (' + Object.keys(kinds).map(function (k) { return k.toLowerCase(); }).join(', ') + '). Run your background through them.'); }
      if ((G.holes || []).length) { var gm = G.holeKind === 'grommet'; legend.push(gm ? { k: 'hidden', t: 'Grey squares: the grommets.' } : { k: 'grommet', t: 'Circles: the hanging holes.' }); extra.push('Keep words and logos away from the ' + (gm ? 'grommets' : 'holes') + '.'); }
      legend.push({ k: 'outside', t: 'Light grey: outside the visible area.' }, { k: 'safe', t: 'Safe line: keep words and logos inside it.' });
      var region = (G.safe && G.safe[0] && G.safe[0].length > 2) ? G.safe[0] : rectPts(v.x, v.y, v.w, v.h);
      var steps = ['Extend the background to the edge of the page. There is no bleed: the page is the cut size.', 'Keep words and logos inside the dashed red line.'];
      extra.forEach(function (x) { steps.push(x); });
      if ((rider ? c.rsides : c.sides) === 2 || c.rider) steps.push('One page per printed side. Save each side as its own file and upload it on the Sign or Rider tab, Front or Back.');
      steps.push('Before you save, hide or delete the layer "' + LAYER + '". It holds these guides and this note.');
      steps.push('Save a PDF, JPG or PNG at this page size (100% scale, up to 25 MB) and upload it in our online designer. It is placed edge to edge.');
      placeNote(pg, region, {
        side: fc[1], product: (info.product || 'Real estate sign') + ' - ' + (rider ? (info.riderSize || '') + ' rider' : (info.size || '')),
        page: 'Template page ' + fmt(W) + ' x ' + fmt(H) + ' in (width x height). This is the print size: keep it at 100%.',
        steps: steps, legend: legend
      }, logo);
      pg.label = fc[1];
      return pg;
    });
    return { pages: pages, name: 'Ardor-Template-' + slug(titleCase(info.product || 'Real Estate Sign')) + '-' + slug(info.sizeName || c.key) + (c.rider ? '-With-' + slug(c.riderSize) + '-Rider' : '') + '-' + (c.sides === 2 ? '2-Sided' : '1-Side') + '.pdf',
      title: 'Ardor Printing print template - ' + (info.product || 'Real estate sign') + ', ' + (info.size || '') + (c.rider ? ', ' + (info.riderSize || '') + ' rider' : ''), data: { sign: c.key, sides: c.sides, rider: c.riderSize || '' } };
  }

  // ---------- the designer on this page ----------
  var DESIGNERS = {
    flag: { id: 'flag', B: 'ArdorFlagBuilder', A: 'ArdorFlagAPI', make: flagDoc },
    table: { id: 'table', B: 'ArdorTableBuilder', A: 'ArdorTableAPI', make: tableDoc },
    stand: { id: 'stand', B: 'ArdorStandBuilder', A: 'ArdorStandAPI', make: standDoc },
    realestate: { id: 'realestate', B: 'ArdorRealestateBuilder', A: 'ArdorRealestateAPI', make: realestateDoc }
  };
  var me = typeof document !== 'undefined' ? document.currentScript : null;
  function which() {
    var m = me && /ardor-(flag|table|stand|realestate)-tpl/.exec(me.src || '');
    if (m && window[DESIGNERS[m[1]].B]) return DESIGNERS[m[1]];
    for (var k in DESIGNERS) if (window[DESIGNERS[k].B] && window[DESIGNERS[k].A]) return DESIGNERS[k];
    return m ? DESIGNERS[m[1]] : null;
  }
  // the template for what is picked now: { blob, name, pages: [{ w, h, label }] }
  function build() {
    var D = which(), B = D && window[D.B], A = D && window[D.A];
    if (!B || !B.cfg) return Promise.reject(new Error('designer not ready'));
    var conf = (A && A.conf) || {};
    return loadLogo(conf.logoUrl).then(function (logo) {
      var d = D.make(B, logo);
      return writePdf({ title: d.title, subject: 'Print template for the Ardor Printing online designer. Hide the layer "' + LAYER + '" before saving.', keywords: 'Ardor Printing, print template, ' + D.id }, d.pages, logo).then(function (blob) {
        return { blob: blob, name: d.name, data: d.data, designer: D.id, pages: d.pages.map(function (p) { return { w: p.W, h: p.H, label: p.label }; }) };
      });
    });
  }
  function track(D, data) {
    var ev = 'ardor_' + D.id + '_template_download';
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, data)); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(ev, data); } catch (e) {}
  }
  var busy = false;
  function download(src) {
    var D = which(), A = D && window[D.A];
    if (busy || !D) return;
    busy = true;
    var els = [].slice.call(document.querySelectorAll('[data-abb-tpl], [data-abb-tpl-link]'));
    els.forEach(function (el) { el.disabled = true; el.setAttribute('aria-busy', 'true'); });
    var lab = document.querySelector('[data-abb-tpl] span'), old = lab ? lab.textContent : '';
    if (lab) lab.textContent = 'Making…';
    build().then(function (r) {
      var url = URL.createObjectURL(r.blob), a = document.createElement('a');
      a.href = url; a.download = r.name; a.rel = 'noopener'; a.style.display = 'none';
      document.body.appendChild(a); a.click();
      setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 30000);
      track(D, Object.assign({ file: r.name, pages: r.pages.length, from: src || 'rail' }, r.data || {}));
      if (A && A.toast) A.toast('Template downloaded: ' + r.name + '. Open it in Illustrator, Photoshop, InDesign or Canva.');
    }).catch(function () {
      if (A && A.toast) A.toast('We couldn\'t make the template. Please try again, or call us at ' + PHONE + '.');
    }).then(function () {
      busy = false;
      els.forEach(function (el) { el.disabled = false; el.removeAttribute('aria-busy'); });
      if (lab) lab.textContent = old || 'Template';
    });
  }
  var ICON = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 3.5h8l4 4v13H6z"/><path d="M14 3.5v4h4"/><path d="M12 10.5v6m0 0 2.6-2.6M12 16.5l-2.6-2.6"/></svg>';
  function style() {
    if (document.getElementById('ardor-tpl-style')) return;
    var st = document.createElement('style'); st.id = 'ardor-tpl-style';
    st.textContent = '.abb-tpl-line{margin:.45rem 0 0}.abb-tpl-link{-webkit-appearance:none;appearance:none;background:none;border:0;padding:0;margin:0;font:inherit;color:var(--abb-accent,#BD252C);text-decoration:underline;text-underline-offset:2px;cursor:pointer;text-align:left}.abb-tpl-link:hover{text-decoration-thickness:2px}.abb-tpl-link[disabled],.abx-tool[data-abb-tpl][disabled]{opacity:.6;cursor:progress}';
    document.head.appendChild(st);
  }
  function mount(tries) {
    var D = which(), B = D && window[D.B], rail = document.querySelector('.abx-rail');
    if (!B || !B.cfg || !rail) { if ((tries || 0) < 80) setTimeout(function () { mount((tries || 0) + 1); }, 250); return; }
    style();
    if (!rail.querySelector('[data-abb-tpl]')) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-tpl', ''); btn.title = 'Download the print template for this size (PDF)';
      btn.innerHTML = ICON + '<span>Template</span>';
      var after = rail.querySelector('[data-abb-pdf]') || rail.querySelector('[data-abx-quote]');
      if (after && after.parentNode === rail) rail.insertBefore(btn, after.nextSibling); else rail.appendChild(btn);
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); download('rail'); });
    }
    var drop = document.querySelector('[data-abb-drop]');
    if (drop && !drop.querySelector('[data-abb-tpl-link]')) {
      var p = document.createElement('p'); p.className = 'abb-help abb-tpl-line';
      p.innerHTML = 'Working with a designer? <button type="button" class="abb-tpl-link" data-abb-tpl-link>Download the template for this size</button>';
      var help = drop.querySelector('.abb-help');
      if (help && help.parentNode === drop) drop.insertBefore(p, help.nextSibling); else drop.appendChild(p);
      p.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); download('artwork'); });
    }
    // the PDF button is added by the designer a moment later: keep the Template button right after it
    if (!rail.querySelector('[data-abb-pdf]') && (tries || 0) < 80) setTimeout(function () { var b = rail.querySelector('[data-abb-tpl]'), pdf = rail.querySelector('[data-abb-pdf]'); if (b && pdf && pdf.nextSibling !== b) rail.insertBefore(b, pdf.nextSibling); }, 3000);
  }
  window.ArdorTemplatePDF = { version: '1.0.1', layer: LAYER, build: build, download: download, mounted: true, _t: { Page: Page, writePdf: writePdf, tw: tw, wrap: wrap, placeNote: placeNote, flagDoc: flagDoc, tableDoc: tableDoc, standDoc: standDoc, realestateDoc: realestateDoc, slug: slug } };
  if (typeof document !== 'undefined' && document.querySelector) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(0); }); else mount(0);
  }
})();
